// Slide 8 - Auto IP (form automator)
import { useState, useEffect } from "react";

const IMAGES = [
  "/autoip/autoip_1.png",
  "/autoip/autoip_2.png",
  "/autoip/autoip_3.png",
  "/autoip/autoip_4.png",
];

export default function Slide8() {
  const [idx, setIdx] = useState(0);
  const [expanded, setExpanded] = useState(false);
  const url = "https://new-autoip.sigma-solution.in/login";

  useEffect(() => {
    if (!expanded) return;
    const onKey = (e) => {
      if (e.key === "Escape") setExpanded(false);
      if (e.key === "ArrowLeft")
        setIdx((s) => (s - 1 + IMAGES.length) % IMAGES.length);
      if (e.key === "ArrowRight") setIdx((s) => (s + 1) % IMAGES.length);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [expanded]);

  return (
    <section className="w-full max-w-[1400px] mx-auto relative z-10 px-6 py-16">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
        <div className="space-y-6 bg-white/6 bg-clip-padding backdrop-blur-sm rounded-3xl p-8 md:p-12 border border-white/12 shadow-2xl">
          <div>
            <span className="inline-block px-4 py-2 bg-white/12 rounded-full text-white text-xs uppercase tracking-widest font-semibold border border-white/20">
              Product
            </span>
            <h2
              className="text-white font-black mt-4 leading-tight"
              style={{ fontSize: "clamp(36px, 5.2vw, 56px)" }}
            >
              Auto IP
            </h2>
            <div
              className="text-white/75 mt-1"
              style={{ fontSize: "clamp(13px, 1.2vw, 15px)" }}
            >
              Form automator — enter details once, export any patent form
              instantly.
            </div>
          </div>

          <p
            className="text-white/90 leading-relaxed"
            style={{ fontSize: "clamp(15px, 1.6vw, 18px)" }}
          >
            AutoIP is a form automator for patent workflows — enter your details
            once and instantly download any patent form you need in the format
            you select.
          </p>

          <ul className="text-white/80 space-y-3">
            <li className="flex items-start gap-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-4 h-4 mt-1 text-white"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <path
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M5 13l4 4L19 7"
                />
              </svg>
              <span>Enter applicant and inventor details once.</span>
            </li>
            <li className="flex items-start gap-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-4 h-4 mt-1 text-white"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <path
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M5 13l4 4L19 7"
                />
              </svg>
              <span>Generate and download multiple legal forms at once.</span>
            </li>
            <li className="flex items-start gap-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-4 h-4 mt-1 text-white"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <path
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M5 13l4 4L19 7"
                />
              </svg>
              <span>
                Saves time for legal teams and startups handling filings.
              </span>
            </li>
          </ul>

          <div className="mt-6 flex flex-col items-start gap-3">
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-white text-slate-900 px-6 py-3 rounded-lg font-semibold shadow hover:shadow-lg"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-4 h-4 text-slate-700"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <path
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8"
                />
              </svg>
              <span>Visit AutoIP</span>
            </a>

            <div className="flex items-center gap-3 text-sm">
              <div className="text-white/70 font-semibold">
                Customized setup in
              </div>
              <div className="relative flex items-center w-4 h-4">
                <span className="absolute inline-flex h-3.5 w-3.5 rounded-full bg-white/60 opacity-75 animate-ping" />
                <span className="relative inline-block h-2.5 w-2.5 rounded-full bg-white shadow" />
              </div>
              <div className="text-white font-medium">
                <span className="keyword">under a week</span>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center lg:items-end w-full">
          <div className="w-full max-w-[900px] bg-white/6 backdrop-blur-sm rounded-2xl p-4 border border-white/12 shadow-xl">
            <div className="relative w-full h-96 md:h-[420px] rounded-lg overflow-hidden bg-white/8 flex items-center justify-center">
              <img
                src={IMAGES[idx]}
                alt={`AutoIP screenshot ${idx + 1}`}
                className="w-full h-full object-contain transition-transform duration-300"
              />

              <button
                onClick={() => setExpanded(true)}
                aria-label="Expand image"
                className="absolute top-3 right-3 bg-white/10 p-2 rounded-md hover:bg-white/16"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5 text-white"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                >
                  <path
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15 3h6v6m-6 0L21 3"
                  />
                  <path
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9 21H3v-6m0 6L9 15"
                  />
                </svg>
              </button>
              {!expanded && (
                <>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setIdx((s) => (s - 1 + IMAGES.length) % IMAGES.length);
                    }}
                    aria-label="Previous image"
                    className="absolute left-3 top-1/2 -translate-y-1/2 bg-black/60 p-3 rounded-full hover:bg-black/50 ring-1 ring-white/10"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-6 h-6 text-white"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                    >
                      <path
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15 18l-6-6 6-6"
                      />
                    </svg>
                  </button>

                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setIdx((s) => (s + 1) % IMAGES.length);
                    }}
                    aria-label="Next image"
                    className="absolute right-3 top-1/2 -translate-y-1/2 bg-black/60 p-3 rounded-full hover:bg-black/50 ring-1 ring-white/10"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-6 h-6 text-white"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                    >
                      <path
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 6l6 6-6 6"
                      />
                    </svg>
                  </button>
                </>
              )}
            </div>

            <div className="mt-3 flex items-center justify-center gap-4">
              {IMAGES.map((src, i) => (
                <button
                  key={src}
                  onClick={() => setIdx(i)}
                  className={`w-20 h-14 rounded-lg overflow-hidden border ${i === idx ? "border-white/40" : "border-white/8"} bg-white/8 transform transition-all hover:scale-105 focus:scale-105`}
                >
                  <img
                    src={src}
                    alt={`thumb-${i}`}
                    className="w-full h-full object-cover"
                  />
                </button>
              ))}
            </div>
          </div>
        </div>
        {expanded && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-6"
            onClick={() => setExpanded(false)}
          >
            <button
              onClick={() => setExpanded(false)}
              aria-label="Close full screen"
              className="absolute top-6 right-6 bg-black/80 p-3 rounded-md hover:bg-black/70 ring-1 ring-white/20 shadow-2xl"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6 text-white"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <path
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            <button
              onClick={(e) => {
                e.stopPropagation();
                setIdx((s) => (s - 1 + IMAGES.length) % IMAGES.length);
              }}
              aria-label="Previous image"
              className="absolute left-6 top-1/2 -translate-y-1/2 bg-white/10 p-3 rounded-full hover:bg-white/16"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6 text-white"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <path
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 18l-6-6 6-6"
                />
              </svg>
            </button>

            <button
              onClick={(e) => {
                e.stopPropagation();
                setIdx((s) => (s + 1) % IMAGES.length);
              }}
              aria-label="Next image"
              className="absolute right-6 top-1/2 -translate-y-1/2 bg-white/10 p-3 rounded-full hover:bg-white/16"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6 text-white"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <path
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 6l6 6-6 6"
                />
              </svg>
            </button>

            <img
              src={IMAGES[idx]}
              alt={`AutoIP full ${idx + 1}`}
              onClick={(e) => e.stopPropagation()}
              className="max-w-full max-h-full object-contain rounded-md shadow-2xl"
            />
          </div>
        )}
      </div>
    </section>
  );
}
